export const StripeSuccessSceneTranslation = {
  fi: {
    StripeSuccessScene: {
      paymentSuccess: 'Ostotapahtuma onnistui!',
      toVehicle: 'Siirry ajoneuvon tietoihin',
    },
  },
};
